<template>
	<div class="container bg-white p-3 border-15 shadow">
		<multi_step_progress
		:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
		:stepper_warning="[]"
		:stepper_danger="[]"
		:completed="2"
		@click="(e) => { val = { page: (e+2), value: value, id: val.id }; $emit('next_page', val); }"
		:click_fnc="$localStorage.get('user').username.role==3"
		/>
		<div class="w-100 overflow-hidden">
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right" :class="(windowWidth > 770) ? 'pr-0' : 'p-0'">
				<selectInput 
					:flds="location.data" 
					:value="value.province" 
					@inputTxtFunc="(e) => { value.province = e; p_sav('province') }" 
					label="استان"
					leading="استان محل زندگی خود را انتخاب کنید. انتخاب استان در جذب کاربران برای تدریس حضوری به شما کمک میکند."
				/>
			</div>
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right" :class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
				<selectInput
					:value="value.county"
					:flds="(value.province == 0) ? [] : location.data[indexFinder(location.data, value.province)].county"
					@inputTxtFunc="(e) => { value.county = e; p_sav('county') }" 
					label="شهر" 
					leading="شهر محل زندگی خود را انتخاب کنید. انتخاب شهر در جذب کاربران برای تدریس حضوری به شما کمک میکند."
				/>
			</div>
		</div>
		<div class="w-100 overflow-hidden">
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right" :class="(windowWidth > 770) ? 'pr-0' : 'p-0'">
				<textInput 
					label="شماره تماس عمومی(اختیاری)" 
					@inputTxtFunc="(e) => { value.public_phone = e;  }" 
					:val="value.public_phone"
					@blurinputTxtFunc="(e) => { p_sav('public_phone') }" 
					leading="این شماره تماس به کاربران نمایش داده می شود."
				/>
			</div>
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right" :class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
				<textInput 
					label="کدپستی" 
					@inputTxtFunc="(e) => { value.postal_code = e;  }" 
					:val="value.postal_code"
					@blurinputTxtFunc="(e) => { p_sav('postal_code') }" 
					leading="کد پستی (10 رقمی) محل زندگی خود را وارد کنید. این اطلاعات به کاربران نمایش داده نمی‌شود."
				/>
			</div>
		</div>
		<textareaInput 
			label="آدرس محل سکونت (این آدرس به کاربر نمایش داده نمیشود)"
			:value="value.home_teacher"
			@blurinputTxtFunc="(e) => { value.home_teacher = e; p_sav('home_teacher') }" 
			leading="آدرس محل سکونت خود را به صورت کامل وارد کنید. این اطلاعات به کاربران نمایش داده نمی‌شود."
			/>
		<div class="d-flex">
			<file_cloud 
				label="بارگزاری کارت ملی"
				:error="false"
				:files="value.files.f1" 
				@chengeFile="(e) => { uploadTF('f1', e);  }"
				@removeFile="(e) => { value.f1 = e;  p_sav('files'); }"
				leading='تصویر کارت ملی خود را آپلود کنید. توجه داشته باشید که از قبل تصویر را تهیه کرده و در این قسمت آن را "بارگزاری" نمایید. این اطلاعات به کاربران نمایش داده نمی‌شود.سایزعکس حداکثر 5مگابایت باشد'
			/>
		</div>
		
		<btn 
		class="pt-3 w-100" 
		textClass="w-100" 
			text="ذخیره نهایی"
			@clickMe="setPage();"
		/>
		<span v-if="!chechRole()">
			<btn 
			type="danger"
				class="pt-3 w-100" 
				textClass="w-100" 
				text="ارسال پیامک"
				@clickMe="send_sms();"
				v-if="$localStorage.get('user').username.role=='3' && ($localStorage.get('user').username.access_level=='0' || $localStorage.get('user').username.access_level=='3')"
				/>
			</span>
			<p v-if="SMS" class="border border-15 p-3 mt-3">
				<b class="text-orange">
					آخرین پیام پشتیبانی:
					<span class="text-gray" style="font-size: 10px;">{{ SMS.date }}</span>
				</b>
				<span class="text-justify text-14"> 
					{{ SMS.text }}
				</span>
			</p>
	</div>
</template>

<script>
	import btn from "../../UI/button/btn.vue";
	import textInput from  "../../UI/input/textInput.vue";
	import textareaInput from  "../../UI/input/textareaInput.vue";
	import selectInput from "../../UI/input/selectInput.vue";
	import file_cloud from "../../UI/uploadFile/file_cloud.vue";
	import { indexFinder } from "../../assets/library/filter.js";
	import { success, error, loading, success_sm } from "../../assets/library/messege.js";
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";

	export default {
		name: 'further_information',
		data(){
			return {
				location: { ok: false, data: [] },
				indexFinder: indexFinder,
				success: success,
				success_sm: success_sm,
				error: error,
				loading: loading,
				SMS: null,
				value:{
					postal_code: '',
					public_phone: '',
					county: 0,
					province: 0,
					home_teacher: "",
					files:{
						f1: [],
						f2: [],
					}
				},
			}
		},
		components: {
			btn,
			multi_step_progress,
			textInput,
			selectInput,
			textareaInput,
			file_cloud,
		},
		props: {
			val: {
				default: {
					page: 1,
				},
			},
		},
		mounted(){
			if(this.val.value!=null){
				this.val = this.val.value;
			}
			this.loader();
			this.get_sms();
		},
		methods:{
			log(e){
				console.log(e, this.val);
			},
//********************************************** */
get_sms(THIS=this){
	window.$.post(window.baseurl + 'teachers/get_SMS', {
		token: THIS.$localStorage.get('user'), 
		id: (THIS.chechRole()) ? this.$localStorage.get("s_id_t") : this.$route.params.id,
		page: 2
	}, function (D) {
		THIS.SMS = D.data
	}, "json");
},
//********************************************** */
	send_sms(THIS=this){
		this.$swal.fire({
			position: 'center',
			type: '',
			title: "ارسال پیامک",
			input: "textarea",
			allowOutsideClick: false,
			showCloseButton: true,
			showConfirmButton: true,
			confirmButtonText: "ارسال",
			confirmButtonClass:"btn btn-outline-success border w-50",
			showCancelButton: true,
			cancelButtonText: "بستن",
			cancelButtonClass:"btn btn-danger w-50",
		}).then((result) => {
			if (result.value) {
				THIS.send_smsF(result.value);
			}			
		})
	},
	//********************************************** */
	send_smsF(text, THIS=this){
		window.$.post(window.baseurl + 'teachers/SMS', {
			token: THIS.$localStorage.get('user'), 
			val : this.val, 
			text: text,
			page: 2
		}, function (D) {
			THIS.success(THIS, 'ارسال شد')
			THIS.get_sms();
	}, "json");
},
//********************************************** */
setPage(){
	if(this.value.county==0 || this.value.province==0 || this.value.postal_code=='' || this.value.home_teacher=='' || this.value.home_teacher==null || this.value.files.f1.length==0 ){
		this.error(this);
	}else{
		this.val = {
			page: 5,
			value: this.value,
			id: this.val.id,
		};
		this.$emit('next_page', this.val);
	}
},
//********************************************** */
loader(THIS = this) {
	window.$.get(window.baseurl + 'location/list', {}, function (D) {
		THIS.location = D;
	}, "json");
	this.val.id = (THIS.chechRole()) ? this.$localStorage.get("s_id_t") : this.$route.params.id;
	if(THIS.chechRole()){
		window.$.get(window.baseurl + 'accountTeacher/'+this.val.id, {}, function (D) {
			
			THIS.value = D.data.username;
			THIS.val.value = D.data.username;
			if(THIS.chechRole()){
				THIS.$localStorage.set('user', D.data);	
				THIS.val.value = THIS.value;
				if(THIS.val.value.status=="10"){
					//نیاز به بررسی
					THIS.val.page = 8;
					THIS.$emit('next_page', THIS.val);
				} else if(THIS.val.value.status=="2" || THIS.val.value.status=="6"){
					// غیر فعال
					THIS.$router.push('/reserved/user/list');
				} 
				else if(THIS.val.value.status=="1"){
					// تایید شده ها
					THIS.val.page = 9;
					THIS.$emit('next_page', THIS.val);
				}
				else if(THIS.val.value.status=="13"){
					//نیاز به بررسی
					THIS.val.page = 8;
					THIS.$emit('next_page', THIS.val);
				}
				else if(THIS.val.value.status=="7"){
					// رها شده
					THIS.$localStorage.set("s_id_t", id);
					THIS.val.page = 4;
					THIS.$emit('next_page', THIS.val);
				}
				else if(THIS.val.value.status=="11"){
					// نقص مدارک
					THIS.val.page = 10;
					THIS.$emit('next_page', THIS.val);
				}
				else if(THIS.val.value.status=="12"){
					// رد شده توسط داور
					THIS.val.page = 11;
					THIS.$emit('next_page', THIS.val);
				} else if(THIS.val.value.status=="5"){
					THIS.$swal.fire({
						position: 'center',
						type: 'error',
						title: 'حساب کاربری شما حذف شده است',
						timer: '2000',
						showConfirmButton: false
					});
					THIS.$localStorage.remove('user');
					THIS.$router.push('/');
				}  else if(THIS.val.value.status=="3"){
					THIS.$swal.fire({
						position: 'center',
						type: 'error',
						title: 'حساب کاربری شما بلاک شده است',
						timer: '2000',
						showConfirmButton: false
					});
					THIS.$localStorage.remove('user');
				}    else if(THIS.val.value.status=="6"){
					THIS.$swal.fire({
						position: 'center',
						type: '',
						title: 'شما درخواست تغییر و یا ارتقا داده اید و درحال بررسی است',
						timer: '2000',
						showConfirmButton: false
					});
				} else {
					THIS.$localStorage.set("s_id_t", id);
					THIS.value.page = 2;
					THIS.$emit('next_page', THIS.value);
				}
			}
		}, "json");
	}else{
		THIS.value = THIS.val;
	}
},
//********************************************** */
p_sav(fild) {
	if(this.$localStorage.get('user')) {
		window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: fild ,val: this.value[fild], id: this.val.id, admin: this.$localStorage.get('user')}, function () {}, "json");
	} else {
		window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: fild ,val: this.value[fild], id: this.val.id}, function () {}, "json");
	}
},
// *********************************************************************
chechRole(){
	let user = this.$localStorage.get('user');
	if(user == null){
		return true;
	}else if(user.username.role != 3){
		return true;
	}else{
		return false;
	}
},
//********************************************** */
uploadTF(val, e, THIS = this) {
	THIS.loading(THIS);
	var formData = new FormData();
	formData.append("file", e);
	formData.append("format", ["jpg", "jpeg", "png", "pdf"]);
	formData.append("idImg", "t_[DATE]_[RANDOM]");
	var xhttp = new XMLHttpRequest();
	xhttp.open("POST", window.upldurl, true);
	xhttp.onreadystatechange = function () {
		if (this.readyState == 4 && this.status == 200) {
			this.getVar = JSON.parse(this.responseText);
			if (this.getVar.response == 1) {
				let F = {
					fileName: this.getVar.filename,
					fileUpload: this.getVar.uploadFileName,
				};
				THIS.value.files[val].push(F);
				THIS.p_sav('files');
				THIS.success_sm(THIS);
			} else {
				THIS.error(THIS, "فرمت فایل باید jpg باشد");
			}
		}
	};
	xhttp.send(formData);
},
//********************************************** */
		}
	}
</script>
<style>

</style>
